export default {
  currentCompanyInfo: {},
  directlySaleCompanyIds: process.env.VUE_APP_DIRECT_SALES_COMPANY_IDS,
};
